import { TimetableDetail } from './timetable-detail';
import { DisplayTemplate } from './display-template';
import { Label } from './label';
import { Template } from './template';
import { TimetableSchedule } from './timetable-schedule';
import { TimetableDetailURLArea } from './timetable-detail-url-area';
import { UserRoute } from './user-route';
import { Area } from './area';

export class TemplateUserRoute {
  displayName: String;
  timetableId: String;
  userRoute: UserRoute;
  areas: Array<Area>;
}

export class TimeTableDisplayRoute {
  routeDisplayName: string;
  stopDisplayName: string;
  templateUserRoute: TemplateUserRoute;
}

export class TimeTableRoute {
  display1: TimeTableDisplayRoute;
  display2: TimeTableDisplayRoute;
}

export class AreaTimeTable {
  timetableId: String;
  timetableIndex: String;
  display?: Number;
}

export class Timetable {
  /**
   * timetable id
   */
  id: Number;
  /**
   * Label
   */
  label: Label;
  /**
   * timetable name
   */
  name: string;
  /**
   * timetable no
   */
  no: string;
  /**
   * suffix
   */
  suffix: string;
  /**
   * display1 templates
   */
  templateDisplay1s: Array<Template>;
  /**
   * display2 templates
   */
  templateDisplay2s: Array<Template>;
  /**
   * displayTemplate1
   */
  displayTemplate1: DisplayTemplate;
  /**
   * displayTemplate2
   */
  displayTemplate2: DisplayTemplate;
  /**
   * true if timetable is checked
   */
  isChecked: boolean;
  /**
   * true if timetable is edited
   */
  isEdit: boolean;
  /**
   * list timetable details
   */
  timetableSchedule: TimetableSchedule;
  /**
   * Timetable Detail
   */
  timetableDetails: Array<TimetableDetail>;

  /**
   * timetableUrLDetails
   */
  timetableUrlDetails: Array<TimetableDetailURLArea>;

  /**
   * true if timetable is expand
   */
  isExpand: boolean;

  /**
   * route of timetable displays
   */
  routeDisplay: TimeTableRoute[];

  constructor(id?: Number, name?: string, no?: string, suffix?: string) {
    this.id = id;
    this.name = name;
    this.no = no;
    this.suffix = suffix;
  }
}
